const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: "/policy",
    exact: true,
    component: "Policy",
  },
];

export default routes;
